<template>
  <div class="user-container" ref="usercontainer">
    <el-card class="box-card">
      <h3 style="text-align: left;padding-bottom: 30px;">筛选</h3>
<!--      <el-form ref="form" :model="form" label-width="80px">-->

<!--        <el-form-item label="所在栏目" style="width:40%;">-->
<!--          <el-select v-model="form" placeholder="请选择单位">-->
<!--            <el-option label="区域一" value="shanghai"></el-option>-->
<!--            <el-option label="区域二" value="beijing"></el-option>-->
<!--          </el-select>-->
<!--          <el-select v-model="form" placeholder="请选择栏目" >-->
<!--            <el-option label="区域一" value="shanghai"></el-option>-->
<!--            <el-option label="区域二" value="beijing"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

<!--      </el-form>-->
    </el-card>
    <el-row class="user-con" style="position: relative">
      <template >
        <el-table
            :data="tableData"
            style="width: 100%;height:100%;">
          <el-table-column
              type="index"
              label="序号"
          >
          </el-table-column>

          <el-table-column
              prop="title"
              label="标题"
          >
          </el-table-column>
          <el-table-column
              prop="writer"
              label="作者"
          >
          </el-table-column>
          <el-table-column
              prop="source"
              label="来源"
          >
          </el-table-column>
          <el-table-column

              label="所属栏目"
          >
            <template  slot-scope="scope">{{ scope.row.columnId | PartentIdtoString}}</template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="创建时间"
          >
          </el-table-column>
          <el-table-column
              prop="pv"
              label="阅读量"
          >
          </el-table-column>
          <el-table-column
              label="操作"
          >
            <template slot-scope="scope">
              <el-row>
                <el-button type="success" icon="el-icon-s-platform" circle @click="openarticle(scope.row.id)"></el-button>
                <el-button type="primary" icon="el-icon-edit" circle @click="openUpdate(scope.row.id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" circle @click="openDelete(scope.row.id)"></el-button>
              </el-row>
            </template>

          </el-table-column>
        </el-table>
      </template>


    </el-row>


    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage1"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total">
      </el-pagination>
    </div>
    <div
        :class="{mydisabled:isDisabled}"
        style="  "
        ref="articleContent"
        >

        <div
            style="width:90%;background: white;margin: 0 auto;height:100%;overflow-y: scroll;z-index: 200"
            v-for="item in oneArticleData" :key="item.index">
          <div style="text-align: right;padding: 20px 20px 0 0;" @click = "closeArticle()">
            <i class="el-icon-close" style="font-size: 30px;font-weight: bold"></i>
          </div>
          <div style="padding: 40px 100px;">
            <h2 style="padding: 20px 0;font-size: 30px">{{item.title}}</h2>
            <hr>
            <div  :class="{articleContentText:true}" style="padding: 20px 0;font-size: 18px;text-align: left" v-html="item.content" ref="articleContentText"></div>
          </div>

        </div>

    </div>


  </div>
</template>

<script>


import {request} from "@/request/request";
import { getCloumnList } from "@/components/api/api";
export default {
  name: "ArticleManAdmin",
  data() {
    return {
      tableData:[],
      oneArticleData:[],
      total:0,
      pageSize:100,
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      dialogFormVisible:false,
      restfulUrl:'articles',//获取全部列表
      getPageCountUrl:'/articles/count',//获取页数
      isDisabled:true,
      articleContentText:true,
      columnList:[],
    }
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    openarticle(uid){
      this.isDisabled = false;
      this.getOneByID(uid)


    },
    openUpdate(uid){
      this.$router.push({name:'articleupdate',params:{id:uid}});
      // this.$router.push('/admin/hsjy/admin/articleupdate/'+uid);

    },
    closeArticle(){
      this.oneArticleData = [];
      this.isDisabled = true;
    },
    openDelete(uid) {
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //删除用户请求
        this.deleteById(uid)
        console.log(uid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //封装API函数
    getData:function(){//获取全部数据
      request({
        method:'GET',
        url:this.restfulUrl,
      }).then(res =>{
        this.tableData = res.data;
      },err=>{
        console.log(err)
      })
    },
    getPageCount:function(){//获取全部页码
      request({
        method:'GET',
        url:this.getPageCountUrl,
      }).then(res =>{
        this.total = res.data;
      },err=>{
        console.log(err)
      })
    },
    getOneByID:function(uid){
      request({
        method:'GET',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        if(res.code==1){
         this.oneArticleData.push(res.data)
        }
      },err=>{
        console.log(err)
      })

    },
    deleteById:function(uid){
      request({
        method:'DELETE',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getData();
        }
      },err=>{
        console.log(err)
      })
    },
    getCloumnListByApi() {

      getCloumnList().then(res => {
        this.columnList = res.data;
        // console.log(this.columnList.length )
        // for (var i=0;i<this.columnList.length;i++){
        //   console.log(this.columnList[i])
        //   if(id == this.columnList[i].id){
        //     newId = this.columnList[i].name;
        //     return newId;
        //   }
        // }
      })
    }

  },
  mounted() {
    this.$refs.articleContent.style = 'height:'+ window.innerHeight + 'px;' + "position:absolute;background:rgba(0,0,0,0.7);width:100%;left:0;top:0;overflow-x: hidden;";
    this.getData();
    this.getPageCount();
    this.getCloumnListByApi();
  },
  filters:{


    PartentIdtoString(id){
      var  newId = '';
      console.log(id)
      console.log(newId)

      // for (var i=0;i<this.columnList.length;i++) {
      //   console.log(this.columnList[i])
      //   // if (id == this.columnList[i].id) {
      //   //   newId = this.columnList[i].name;
      //   //   return newId;
      //   // }
      // }
      // if(id ==4){
      //   newId = '通知公告'
      // }
      // else if(id ==5){
      //   newId = '馆内新闻'
      // }
      // else if(id ==6){
      //   newId = '活动接待'
      // }
      // else if(id ==7){
      //   newId = '学术研究'
      // }
      // else if(id ==8){
      //   newId = '宣教之窗'
      // }
      // else if(id ==9){
      //   newId = '流动巡展'
      // }
      // else if(id ==10){
      //   newId = '主题活动'
      // }
      // else if(id ==11){
      //   newId = '民族团结'
      // }
      // else if(id ==12){
      //   newId = '烽火岁月'
      // }
      // else if(id ==13){
      //   newId = '英烈风采'
      // }
      // else if(id ==14){
      //   newId = '网站用文章'
      // }
      // else if(id ==15){
      //   newId = '培训动态'
      // }
      // else if(id ==16){
      //   newId = '开班信息'
      // }
      // else if(id ==17){
      //   newId = '精品课程'
      // }
      // else if(id ==18){
      //   newId = '特色案例'
      // }
      // else if(id ==19){
      //   newId = '现场教学点'
      // }
      // else if(id ==20){
      //   newId = '培训基地'
      // }
      // else if(id ==21){
      //   newId = '教学形式'
      // }
      // else if(id ==22){
      //   newId = '精品路线'
      // }
      // else{
      //   newId = '其他'
      // }
      // return newId
    },
  }
}


</script>

<style scoped>
.user-button{
  text-align: left;
  padding:0 10px 10px;
  border-bottom: 1px solid rgb(165,165,165);

}
.user-container{
  height:100%;
}
.user-con{
  padding:40px;
}
.mydisabled {
  display: none;

}

</style>

<style>
.articleContentText p img{
  width:100%;
  margin-left: -2em;
}

.articleContentText p {
  margin-bottom: 10px;
  text-indent: 2em;
}
</style>
